import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// mui components
import {
    Typography,
} from "@mui/material";


const AnalyticsPage = () => {
    const profile = useSelector(state => state.auth.profile);
    let parent_id = (profile && profile.parent_id) ? profile.parent_id: "";
    let url = 'https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/031200354948/dashboards/f129e985-e14e-41bd-84a4-8de819df3f1c?directory_alias=shippingchimp#p.tag='+parent_id;
    console.log(url);
    return (
        <>
            <div className="scmaincard">
                <div className="sccardhead">
                        <div  style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant="h5" gutterBottom component="div">
                                Analytics
                            </Typography>
                        </div>
                       
                </div>
                <div>
                    <Card sx={{ minWidth: '100%' }} className="sc--cardhead--details">
                        <CardContent>
                            <iframe
                                    width="100%"
                                    height="720"
                                    style={{ border:"none"}}
                                    src={url}>
                            </iframe>
                        </CardContent>
                    </Card>
                </div>
                
            </div >
        </>
    );
}

export default AnalyticsPage;